<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                cols="12"
                md="6"
            >
                <v-card>
                    <v-form
                        ref="incidentForm"
                        v-model="isValid"
                    >
                        <v-card-text>
                            <v-container
                                class="pb-0"
                                fluid
                            >
                                <v-row class="pb-0">
                                    <v-col
                                        cols="12"
                                        v-if="incidentIn.isLateRegistrationSuspended === true"
                                    >
                                        <v-switch
                                            class="mb-0"
                                            label="Unsuspend Incident, suspended due to late registration."
                                            v-model="incident.isLateRegistrationApproved"
                                        ></v-switch>
                                    </v-col>
                                    <v-expand-transition>
                                        <v-col
                                            cols="12"
                                            v-if="incidentIn.isLateRegistrationSuspended === true"
                                            v-show="incidentIn.isLateRegistrationSuspended === true && incident.isLateRegistrationApproved"
                                        >
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[v => (!incident.isLateRegistrationApproved || requiredRule(v)), lengthRule(50)]"
                                                label="Authorization Code"
                                                v-model="authorizationToken"
                                            >
                                                <template v-slot:append>
                                                    <v-btn
                                                        :disabled="isLoading || isRequestingAuthToken"
                                                        :loading="isRequestingAuthToken"
                                                        @click="requestAuthorizationToken"
                                                        class="text-none"
                                                        color="light-blue darken-1"
                                                        text
                                                        v-if="isRequestingAuthToken === true || isRequestingAuthToken === null"
                                                    >Request</v-btn>

                                                    <v-btn
                                                        @click.stop
                                                        class="text-none"
                                                        disabled
                                                        text
                                                        v-else
                                                    >Requested</v-btn>
                                                </template>
                                            </v-text-field>
                                            <v-btn
                                                :disabled="isLoading"
                                                @click="showAuthorizers"
                                                class="text-none"
                                                color="light-blue darken-1"
                                                text
                                            >
                                                <v-icon
                                                    dark
                                                    left
                                                >mdi-account</v-icon>Show Authorizers
                                            </v-btn>
                                        </v-col>
                                    </v-expand-transition>
                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading"
                                            :items="activeProviders"
                                            :rules="[requiredRule]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Provider"
                                            v-model="incident.providerId"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading"
                                            :items="sapdMetros"
                                            :rules="[requiredRule]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Sapd Metro"
                                            v-model="incident.sapdMetroId"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[requiredRule, lengthRule(30)]"
                                            label="Vehicle Registration Number"
                                            v-model="incident.vehicleRegistrationNumber"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            min-width="290px"
                                            offset-y
                                            transition="scale-transition"
                                            v-model="dateMenu"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    label="Date Of Incident"
                                                    prepend-icon="mdi-calendar-month"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="inputDate"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                @input="dateMenu = false"
                                                color="secondary"
                                                v-model="inputDate"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            max-width="290px"
                                            min-width="290px"
                                            offset-y
                                            ref="menu"
                                            transition="scale-transition"
                                            v-model="timeMenu"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    label="Time Of Incident"
                                                    prepend-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-model="inputTime"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                @click:minute="timeMenu = false"
                                                color="secondary"
                                                full-width
                                                v-if="timeMenu"
                                                v-model="inputTime"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-divider></v-divider>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Incident Address Line 1"
                                            v-model="incident.addressLine1"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Incident Address Line 2"
                                            v-model="incident.addressLine2"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(100)]"
                                            label="Incident Address Line 3"
                                            v-model="incident.addressLine3"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(30)]"
                                            label="Incident City"
                                            v-model="incident.city"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[lengthRule(30)]"
                                            label="Incident Province"
                                            v-model="incident.province"
                                        ></v-text-field>
                                    </v-col>

                                    <v-divider></v-divider>
                                    <v-col
                                        cols="12"
                                        justify="start"
                                    >
                                        <v-btn
                                            @click="loadIdentityFindAddForm"
                                            class="text-none"
                                            color="light-blue darken-1"
                                            dark
                                            v-if="!incident.driverIdentityId"
                                        >
                                            <v-icon
                                                dark
                                                left
                                            >mdi-steering</v-icon>Specify Driver
                                        </v-btn>
                                        <v-btn
                                            @click="incident.driverIdentityId = null"
                                            class="text-none"
                                            color="light-blue darken-1"
                                            text
                                            v-else
                                        >
                                            <v-icon
                                                dark
                                                left
                                            >mdi-close</v-icon>Clear Driver
                                        </v-btn>
                                        <v-card
                                            @click="loadIdentityForm(incident.driverIdentity)"
                                            v-if="incident.driverIdentityId"
                                        >
                                            <v-card-text>
                                                {{ incident.driverIdentity.name }}
                                                {{ incident.driverIdentity.surname }}
                                                <br />
                                                <span v-if="identityTypes">
                                                    {{
                                                    identityTypes.find(
                                                    (x) => x.key == incident.driverIdentity.identityTypeId
                                                    ).value
                                                    }}
                                                </span>
                                                <br />
                                                {{ incident.driverIdentity.identificationNumber }}
                                            </v-card-text>
                                        </v-card>
                                        <br />
                                        <div
                                            style="color: red"
                                            v-show="incident.driverIdentityId === 0"
                                        >Driver identity is required</div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Driver License Available"
                                            v-model="incident.driverLicenseAvailable"
                                            v-show="!incident.driverLicenseFileId && !driverLicense"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-file-input
                                            :disabled="isLoading"
                                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                                            label="Driver License"
                                            placeholder="Set Driver License"
                                            v-model="driverLicense"
                                        >
                                            <template slot="append-outer">
                                                <v-icon
                                                    color="light-green"
                                                    v-show="incident.driverLicenseFileId > 0"
                                                >mdi-check</v-icon>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row v-if="enableArRequirements">
                                    <!-- Accident Report inputs start -->
                                    <v-col cols="12">
                                        <v-switch
                                            class="mb-0"
                                            label="Accident Report Registered"
                                            v-model="incident.isArRegistered"
                                        ></v-switch>
                                    </v-col>
                                    <v-expand-transition>
                                        <v-col
                                            cols="12"
                                            v-show="requireNotArRegisteredNote"
                                        >
                                            <v-textarea
                                                :rules="[requireNotArRegisteredNoteRule, lengthRule(512)]"
                                                counter
                                                label="Why isn't the incident AR registered?"
                                                v-model="incident.notArRegisteredNote"
                                            ></v-textarea>
                                        </v-col>
                                    </v-expand-transition>
                                    <v-expand-transition>
                                        <v-col
                                            cols="12"
                                            v-show="incident.isArRegistered"
                                        >
                                            <v-text-field
                                                :disabled="isLoading"
                                                :rules="[arRequirementRule, lengthRule(50)]"
                                                label="Accident Report Number"
                                                v-model="incident.accidentReportNumber"
                                            ></v-text-field>

                                            <v-switch
                                                :disabled="isLoading"
                                                class="mb-0"
                                                label="Accident Report Available"
                                                v-model="incident.accidentReportAvailable"
                                                v-show="!incident.accidentReportFileId && !accidentReport"
                                            ></v-switch>

                                            <v-file-input
                                                :disabled="isLoading"
                                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                                label="Accident Report"
                                                placeholder="Set Accident Report"
                                                v-model="accidentReport"
                                            >
                                                <template slot="append-outer">
                                                    <v-icon
                                                        color="light-green"
                                                        v-show="incident.accidentReportFileId > 0"
                                                    >mdi-check</v-icon>
                                                </template>
                                            </v-file-input>

                                            <v-expand-transition>
                                                <v-textarea
                                                    :rules="[requireNotArUploadedNoteRule, lengthRule(512)]"
                                                    counter
                                                    label="Why isn't the AR document uploaded?"
                                                    v-model="incident.notArUploadedNote"
                                                    v-show="requireNotArUploadedNote"
                                                ></v-textarea>
                                            </v-expand-transition>
                                        </v-col>
                                    </v-expand-transition>
                                    <!-- Accident Report inputs end -->

                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Incident Report Available"
                                            v-model="incident.incidentReportAvailable"
                                            v-show="!incident.incidentReportFileId && !incidentReport"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-file-input
                                            :disabled="isLoading"
                                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                                            label="Incident Report"
                                            placeholder="Set Incident Report"
                                            v-model="incidentReport"
                                        >
                                            <template slot="append-outer">
                                                <v-icon
                                                    color="light-green"
                                                    v-show="incident.incidentReportFileId > 0"
                                                >mdi-check</v-icon>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading || !canEditIsFraudulent"
                                            label="Fraudulent"
                                            v-model="incident.isFraudulent"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-switch
                                            :disabled="isLoading || !canEditIsSuspended"
                                            label="Accident Report Suspended"
                                            v-model="incident.isSuspended"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        v-if="showIsFinalised"
                                    >
                                        <v-switch
                                            :disabled="isLoading || !canEditIsFinalised"
                                            label="Finalised"
                                            v-model="incident.isFinalised"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-5 pb-10"
                                    justify="space-between"
                                    no-gutters
                                    v-if="canDownloadIncidentLog"
                                >
                                    <v-col cols="12">
                                        <v-btn
                                            :disabled="isLoading"
                                            :loading="isGettingIncidentLog"
                                            @click="getIncidentLog"
                                            class="text-none"
                                            color="secondary darken-1"
                                            v-show="incident.id > 0"
                                        >Get Incident Log</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                                >
                                    <v-btn
                                        :disabled="isLoading && !isDeleting"
                                        :loading="isDeleting"
                                        @click="deleteEntity"
                                        class="text-none"
                                        color="warning darken-1"
                                        text
                                        v-show="incident.id > 0"
                                    >Delete</v-btn>
                                    <v-spacer></v-spacer>
                                    <!--<v-btn
                                    :disabled="isLoading"
                                    @click="closeForm"
                                    class="text-none"
                                    color="secondary darken-1"
                                    text
                                    >Close</v-btn>-->
                                    <v-btn
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >{{ incident.id > 0 ? "Update" : "Add" }}</v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar
                        :color="notifyColor"
                        :timeout="15000"
                        top
                        v-model="notifyShow"
                    >
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                @click="notifyShow = false"
                                class="text-none"
                                icon
                                v-bind="attrs"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                md="6"
                no-gutters
            >
                <v-col
                    cols="12"
                    v-show="incident.id > 0"
                >
                    <h3>
                        Patients
                        <v-btn
                            :disabled="isLoading"
                            @click="newPatient"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-col
                        :key="patient.id"
                        cols="12"
                        justify="start"
                        no-gutters
                        v-for="patient in incident.patients"
                    >
                        <v-card @click="loadPatientForm(patient.id)">
                            <v-card-text>
                                <v-row>
                                    <v-col
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        {{ patient.identity.name }} {{ patient.identity.surname }}
                                        <br />
                                        <span v-if="identityTypes">
                                            {{
                                            identityTypes.find(
                                            (x) => x.key == patient.identity.identityTypeId
                                            ).value
                                            }}
                                        </span>
                                        <br />
                                        {{ patient.identity.identificationNumber }}
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Consent Form
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="patient.consentFormFileId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="info"
                                                    v-else-if="patient.consentFormAvailable"
                                                >mdi-alpha-a-circle</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Amb Report
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="patient.ambulanceReportFileId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="info"
                                                    v-else-if="patient.ambulanceReportAvailable"
                                                >mdi-alpha-a-circle</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Transfer Let
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="patient.transferLetterFileId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="info"
                                                    v-else-if="patient.transferLetterAvailable"
                                                >mdi-alpha-a-circle</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-card-subtitle class="ma-0 pa-0">
                                    <strong>Member Id: {{patient.mediKreditAddCardId > 0 ? patient.id : "n/a"}}</strong>
                                </v-card-subtitle>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-col>
                <v-col
                    cols="12"
                    v-show="incident.id > 0"
                >
                    <h3>
                        Notes
                        <v-btn
                            :disabled="isLoading"
                            @click="newNoteShow = true"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-col
                        :key="note.id"
                        cols="12"
                        justify="start"
                        no-gutters
                        v-for="note in incident.notes"
                    >
                        <v-card>
                            <v-card-subtitle>
                                {{ note.author }}
                                <br />
                                {{ note.createdAt }}
                            </v-card-subtitle>
                            <v-card-text>{{ note.text }}</v-card-text>
                        </v-card>
                    </v-col>
                </v-col>
            </v-col>
            <v-dialog
                persistent
                v-model="identityFindAddFormVisible"
                width="500px"
            >
                <IdentityFindAddForm
                    :allowDeceased="true"
                    :key="identityFindAddFormKey"
                    @close="closeIdentityFindAddForm"
                    @located="locatedIdentity"
                />
            </v-dialog>
            <v-dialog
                persistent
                v-model="patientFormVisible"
                width="500px"
            >
                <PatientForm
                    :incident-id="incident.id"
                    :key="patientFormPatientId"
                    :patient-id="patientFormPatientId"
                    :provider-id="incident.providerId"
                    @close="closePatientForm"
                    @deleted="deletedPatient"
                    @saved="savedPatient"
                    @savedIdentity="savedIdentity"
                />
            </v-dialog>
            <v-dialog
                persistent
                v-model="identityFormVisible"
                width="500px"
            >
                <IdentityForm
                    :hide-delete="true"
                    :identity-in="identityFormIdentity"
                    :identity-types="identityTypes"
                    :key="identityFormKey"
                    @close="closeIdentityForm"
                    @saved="savedIdentity"
                />
            </v-dialog>

            <v-dialog
                persistent
                v-model="newNoteShow"
                width="500px"
            >
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-textarea
                            :rules="[lengthRule(512)]"
                            counter
                            label="Note"
                            v-model="newNoteText"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            @click="
              () => {
                newNoteShow = false;
                newNoteText = '';
              }
            "
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="isLoading || newNoteAdding || newNoteText.length == 0"
                            :loading="newNoteAdding"
                            @click="newNoteAdd"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Add</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="authorizersShow"
                width="500px"
            >
                <v-card>
                    <v-card-title>Provider Authorizers</v-card-title>
                    <v-card-text>
                        <template v-if="patientAuthorizers && patientAuthorizers.length > 0">
                            <v-list-item
                                :key="index"
                                two-line
                                v-for="(autho, index) in patientAuthorizers"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>{{ autho.key }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ autho.value }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <span v-else>No Authorizers are registered for this provider.</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="authorizersShow = false"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-show="populating == true">
            <v-col
                class="text-center"
                cols="12"
            >
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                class="text-center"
                cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
        </v-row>
    </v-container>
</template>

<script>
import EntityType from "../../constants/EntityType.constant";
import Incident from "../../models/Incident.model";
import dateToString from "../../helpers/dateToString";
import timeToString from "../../helpers/timeToString";
import IdentityFindAddForm from "../forms/IdentityFindAddForm";
import PatientForm from "../forms/PatientForm";
import Identity from "../../models/Identity.model";
import IdentityForm from "./IdentityForm";
import uuid4 from "../../helpers/uuid4";
import RoleType from "../../constants/RoleType.constant";
import fileDownload from "js-file-download";
export default {
    props: {
        incidentId: {
            type: Number,
            default: 0
        },
        sapdMetros: {
            type: Array,
            default: new Array()
        },
    },
    components: {
        IdentityFindAddForm,
        PatientForm,
        IdentityForm
        //
    },
    created: async function() {
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
    },
    mounted: async function() {
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.providers = await this.$store.dispatch("providers/getlist");

        await this.loadIncident();
    },
    data() {
        return {
            incidentIdValue: this.incidentId,
            populating: true,
            populatingFailure: true,
            requestId: uuid4(),
            userRoles: [],
            providers: [],
            activeProviders: [],
            incident: {},
            incidentIn: {},
            identityTypes: null,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isSendingWelcome: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",
            arRequirementRule: v =>
                !this.incident.isArRegistered || !!v || "required",
            requireNotArRegisteredNoteRule: v =>
                this.requireNotArRegisteredNote == false || !!v || "required",
            requireNotArUploadedNoteRule: v =>
                this.requireNotArUploadedNote == false || !!v || "required",
            /*
            accountnumberRule: v =>
                !!v ||
                (!this.incident.accidentReportFileId &&
                    !this.accidentReport &&
                    !this.incident.incidentReportFileId &&
                    !this.incidentReport) ||
                "required",
                */
            dateMenu: false,
            timeMenu: false,

            identityFindAddFormVisible: false,
            identityFindAddFormKey: 0,
            identityFindAddFormTarget: null,

            patientFormPatientId: -1,
            patientFormVisible: false,

            driverLicense: null,
            accidentReport: null,
            incidentReport: null,

            //identity form
            identityFormVisible: false,
            identityFormKey: 0,
            identityFormIdentity: new Identity(),

            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",

            inputDate: null,
            inputTime: null,

            authorizationToken: "",
            isRequestingAuthToken: null,
            patientAuthorizers: [],
            authorizersShow: null,

            notArRegisteredNote: "",
            notArUploadedNote: "",

            isGettingIncidentLog: false
        };
    },
    computed: {
        requireNotArRegisteredNote() {
            if (
                !this.incident.isArRegistered &&
                (!(this.incident.id > 0) || !!this.incidentIn.isArRegistered)
            )
                return true;
            else return false;
        },
        requireNotArUploadedNote() {
            if (
                !!this.incident.isArRegistered &&
                //!this.requireNotArRegisteredNote &&
                !(
                    this.incident.accidentReportFileId > 0 ||
                    this.accidentReport
                ) &&
                (!(this.incident.id > 0) || !this.incidentIn.isArRegistered)
            )
                return true;
            else return false;
        },
        enableArRequirements: function() {
            return (
                this.userRoles.length == 0 ||
                this.userRoles.some(x => x != RoleType.IncidentReporter)
            );
        },
        canEditIsSuspended: function() {
            return this.userRoles.some(
                x => x == RoleType.Admin || x == RoleType.CaseAdministrator
            );
        },
        canEditIsFraudulent: function() {
            return this.userRoles.some(
                x => x == RoleType.Admin || x == RoleType.CaseAdministrator
            );
        },
        showIsFinalised: function() {
            return this.userRoles.some(x => x == RoleType.Admin);
        },
        canEditIsFinalised: function() {
            return (
                (this.incident.accidentReportFileId > 0 ||
                    this.accidentReport) &&
                this.accidentReportNumber != "" &&
                this.userRoles.some(x => x == RoleType.Admin)
            );
        },
        canDownloadIncidentLog: function() {
            return this.userRoles.some(x => x == RoleType.Admin);
        }
    },
    methods: {
        clearUploadInputs() {
            this.driverLicense = null;
            this.accidentReport = null;
            this.incidentReport = null;
        },
        async loadIncident() {
            this.populating = true;
            this.populatingFailure = true;

            if (this.incidentIdValue > 0) {
                var requestId = (this.requestId = uuid4());
                var incidentResponse = await this.$store.dispatch(
                    "incidents/get",
                    {
                        id: this.incidentIdValue,
                        urlParameters: {},
                        requestId: requestId
                    }
                );
                if (
                    this.requestId == incidentResponse.requestId &&
                    incidentResponse.data.total == 1 &&
                    incidentResponse.data.page[0].entity.id ==
                        this.incidentIdValue
                ) {
                    this.clearUploadInputs();                    
                    this.incidentIn = incidentResponse.data.page[0].entity;
                    this.setActiveProvider(this.incidentIn.providerId);
                    this.incident = new Incident().set(this.incidentIn);
                    this.populatingFailure = false;
                }
            } else if (this.incidentIdValue === 0) {
                this.setActiveProvider();
                this.incident = new Incident();
                this.populatingFailure = false;
            }
            this.getDateTimeValuesFromIncident();
            this.populating = false;
        },
        setActiveProvider(providerId)
        {
            this.activeProviders = this.providers.filter(x => x.disabled == false || (providerId > 0 && x.key == providerId)).map(x => {const obj = {}; obj.value = x.value; obj.key = x.key; return obj;});
        },
        //late suspension authorization token methods
        showAuthorizers() {
            this.$store
                .dispatch(
                    "providers/getIncidentAuthorizers",
                    this.incident.providerId
                )
                .then(
                    response => {
                        this.patientAuthorizers = response;
                        this.authorizersShow = true;
                        //  this.notify(
                        //     (response && response.length > 0)? response.reduce((x, a) => x + "<br>" + a.key + ": " + a.value, "" ) : "No Authorizers are registered for this provider.",
                        //    "secondary"
                        //);
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.deleteEntityDone);
        },

        requestAuthorizationToken() {
            this.isRequestingAuthToken = true;

            this.$store
                .dispatch("authorizationTokens/requestNew", {
                    entityType: EntityType.Incident,
                    entityId: this.incident.id
                })
                .then(
                    () => {
                        this.notify(
                            "Token request sent. An area supervisor will contact you.",
                            "success"
                        );
                        this.isRequestingAuthToken = false;
                    },
                    error => {
                        this.notify(error.response.data, "error");
                        this.isRequestingAuthToken = null;
                    }
                );
        },
        //-----------------------------------
        getDateTimeValuesFromIncident() {
            var inputDateTime = this.incident.dateOf
                ? new Date(this.incident.dateOf)
                : new Date();
            this.inputDate = dateToString(inputDateTime);
            this.inputTime = timeToString(inputDateTime);
        },
        newNoteAdd() {
            this.isLoading = true;
            this.newNoteAdding = true;
            this.$store
                .dispatch("incidents/addNote", {
                    incidentId: this.incident.id,
                    text: this.newNoteText
                })
                .then(
                    response => {
                        this.incident.notes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newNoteAddingDone();
                        this.newNoteShow = false;
                        this.newNoteText = "";
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newNoteAddingDone);
        },
        newNoteAddingDone() {
            this.newNoteAdding = false;
            this.isLoading = false;
        },
        //subform handleser --------------------------------------------------------
        async savedPatient(/*patientIn*/) {
            await this.loadIncident();
            /*
            var updateIndex = this.incident.patients.findIndex(
                x => x.id == patientIn.entity.id
            );
            if (updateIndex > -1)
                this.$set(
                    this.incident.patients,
                    updateIndex,
                    patientIn.entity
                );
            else this.incident.patients.push(patientIn.entity);
            */
            this.emitSavedEntity(this.incident);
        },
        savedIdentity(identityIn) {
            this.incident.patients.forEach(patient => {
                if (patient.identity.id == identityIn.entity.id)
                    patient.identity = identityIn.entity;
            });

            if (this.incident.driverIdentity.id == identityIn.entity.id)
                this.incident.driverIdentity = identityIn.entity;

            this.emitSavedEntity(this.incident);
        },
        deletedPatient(patientIn) {
            var deletedIndex = this.incident.patients.findIndex(
                x => x.id == patientIn.id
            );
            if (deletedIndex > -1)
                this.$delete(this.incident.patients, deletedIndex);

            this.emitDeletedPatient(patientIn);
        },
        newPatient() {
            //var patient = new Patient();
            //patient.id = 0;
            //patient.incidentId = this.incident.id;
            this.loadPatientForm(0);
        },
        loadPatientForm(patientId) {
            this.patientFormPatientId = patientId;
            this.patientFormVisible = true;
        },
        closePatientForm() {
            this.patientFormPatientId = -1;
            this.patientFormVisible = false;
        },

        loadIdentityFindAddForm() {
            this.identityFindAddFormKey += 1;
            this.identityFindAddFormVisible = true;
        },
        closeIdentityFindAddForm() {
            this.identityFindAddFormVisible = false;
        },
        locatedIdentity(identity) {
            this.incident.driverIdentityId = identity.id;
            this.incident.driverIdentity = identity;
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedIncident) {
            this.$emit("saved", savedIncident);
        },
        emitDeletedEntity(deletedIncident) {
            this.$emit("deleted", deletedIncident);
        },
        emitDeletedPatient(deletedPatient) {
            this.$emit("deletedPatient", deletedPatient);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.incidentForm.validate();

            if (!(this.incident.driverIdentityId > 0))
                this.incident.driverIdentityId = 0;

            if (this.isValid) return this.incident.driverIdentityId > 0;
            else return false;
        },

        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                this.incident.dateOf = this.inputDate + "T" + this.inputTime;

                var formdata = new FormData();
                formdata.append("DriverLicense", this.driverLicense);
                formdata.append("AccidentReport", this.accidentReport);
                formdata.append("IncidentReport", this.incidentReport);
                formdata.append("Model", JSON.stringify(this.incident));
                formdata.append("AuthorizationToken", this.authorizationToken);

                const parameters = {
                    id: this.incident.id,
                    formData: formdata
                };
                var hasId = this.incident.id > 0;
                try {
                    var incidentWithInfo = await this.$store.dispatch(
                        "incidents/" + (hasId ? "update" : "create"),
                        hasId ? parameters : parameters.formData
                    );
                    this.notify("Incident successfully saved.", "success");
                    if (!(this.incident.id > 0)) {
                        this.incident.id = incidentWithInfo.entity.id;
                        this.incidentIdValue = this.incident.id;
                    }
                    this.emitSavedEntity(incidentWithInfo);
                    await this.loadIncident();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingWelcome = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this incident?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("incidents/delete", this.incident.id)
                    .then(
                        () => {
                            this.notify(
                                "Incident successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.incident);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },

        //IdentityForm Methods
        loadIdentityForm(identity) {
            this.identityFormIdentity = new Identity().set(identity);
            this.identityFormKey = identity.id;
            this.identityFormVisible = true;
        },
        closeIdentityForm() {
            this.identityFormVisible = false;
            this.identityFormIdentity = new Identity();
            this.identityFormKey = null;
        },
        getIncidentLog() {
            this.isLoading = true;
            this.isGettingIncidentLog = true;
            this.$store
                .dispatch("reports/getincidentlog", {
                    incidentId: this.incident.id
                })
                .then(
                    response => {
                        this.notify("Downloading...", "success", 3000);
                        fileDownload(
                            response.data,
                            response.headers["content-disposition"].match(
                                /filename\s*=\s*(.+);/i
                            )[1]
                        );
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.getIncidentLogDone);
        },
        getIncidentLogDone() {
            this.isLoading = false;
            this.isGettingIncidentLog = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>